<template>
    <span class="inline-flex h-7 w-7 items-center justify-center">
        <span v-if="cell.effective" :class="grantedClasses" class="inline-flex h-5 w-5 items-center justify-center rounded-full">
            <icon class="!h-3 !w-3" icon="cil-check-alt" />
        </span>
        <span v-else :class="revokedClasses" class="inline-flex h-5 w-5 items-center justify-center rounded-full">
            <icon class="!h-3 !w-3" icon="cil-x" />
        </span>
    </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    cell: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
});

const isOverride = computed(() => props.cell.override !== null);
const grantedClasses = computed(() => {
    if (isOverride.value) {
        return 'bg-white text-green-600';
    }
    return props.readonly ? 'bg-gray-300' : 'bg-green-600 text-white';
});
const revokedClasses = computed(() => (isOverride.value ? 'bg-white text-red-600' : 'bg-red-600 text-white'));
</script>
